// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 2058) return "static/chunks/2058-1d6aaf3ff0d0fd73.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 3342 ? "ea88be26" : chunkId) + "." + {"292":"71f8c1456938111e","1423":"606547879d3ab052","3049":"f0a2ae011b278fc3","3342":"92885f2f6702866f","3499":"8bd02b9fb28a526b","4779":"8e0e7822cda316a1","9447":"e356973b84f00c2d"}[chunkId] + ".js";
};